// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1c6aK","column":"style_column__2vhzN","row":"style_row__3zcDF"};